import { useEffect } from 'react';

/**
 * Hook to listen for clicks outside of the target elements
 * @param {Function} callback - The function to call when a click outside is detected
 * @param {Array<React.RefObject>} refs - An array of refs of the target elements
 */
const useClickAway = (callback, refs) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (refs.every((ref) => ref.current && !ref.current.contains(event.target))) {
        callback();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [callback, refs]);
};

export default useClickAway;
